import Swal from 'sweetalert2';

export const mensajeExito = (tit, txt) => {
   return Swal.fire({
      position: 'center',
      icon: 'success',
      title: tit,
      text: txt,
      confirmButtonColor: '#3B82F6',
      showConfirmButton: false,
      timer: 2500,
      customClass: {
         popup: 'swal2-custom-popup',
         icon: 'swal2-custom-icon',
         title: 'swal2-custom-title',
      },
   });
};

// Variante de éxito en modal, sin cierre automático (requiere que el usuario
// confirme), para casos donde necesita quedarse a chequear el detalle.
// El html debe llegar ya escapado por el caller donde corresponda, esta
// función no sanitiza.
export const mensajeExitoDetalle = (tit, html) => {
   return Swal.fire({
      position: 'center',
      icon: 'success',
      title: tit,
      html,
      confirmButtonColor: '#3B82F6',
      confirmButtonText: 'Aceptar',
      customClass: {
         popup: 'swal2-custom-popup',
         icon: 'swal2-custom-icon',
         title: 'swal2-custom-title',
      },
   });
};

export const mensajeError = (tit, tex) => {
   return Swal.fire({
      icon: 'error',
      confirmButtonColor: '#3B82F6',
      title: tit,
      text: tex, //`${res.data.descripcion}`,
   });
};

// Variante para errores con contenido HTML (ej: listado de errores por fila).
// El html debe llegar ya escapado por el caller, esta función no sanitiza.
export const mensajeErrorDetalle = (tit, html) => {
   return Swal.fire({
      icon: 'error',
      confirmButtonColor: '#3B82F6',
      title: tit,
      html,
      width: '38rem',
   });
};

export const mensajeConfirmacion = (
   tit,
   txt,
   confirmText = 'Aceptar',
   cancelText = 'Cancelar',
) => {
   return Swal.fire({
      title: tit,
      html: txt,
      icon: 'success',
      //showCancelButton: true,
      confirmButtonColor: '#3085d6',
      //cancelButtonColor: '#d33',
      confirmButtonText: confirmText,
      cancelButtonText: cancelText,
   });
};

export const mensajeAlerta = (
   tit,
   txt,
   confirmText = 'Aceptar',
   cancelText = 'Cancelar',
) => {
   return Swal.fire({
      title: tit,
      html: txt,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: confirmText,
      cancelButtonText: cancelText,
   });
};

// Agrega estilos en línea
const style = document.createElement('style');
style.innerHTML = `
  .swal2-container {
      z-index: 9999; 
   }
   .swal2-custom-popup {
      width: 25rem;
      padding: 20px;
      border-radius: 10px;      
      box-shadow:
      0 12px 64px -4px rgba(35, 21, 91, 0.03),
      0 8px 12px -6px rgba(35, 21, 91, 0.03);
      
   }
   .swal2-custom-icon {
      color: #4caf50;
   }
   .swal2-icon {
      margin-top:0.6rem;
   }
   .swal2-custom-title {
      font-size: 1.7rem;
   }
`;
document.head.appendChild(style);
